<template>
	<v-row class="deviceBuyout__form collect">
		<v-col>
			<v-row class="collect__detail">
				<v-col class="collect__receipt" v-if="mustHaveReciept">
					<div class="collect__title">
						{{ $t('buyout.AdditionalInfoForm.reciept') }}
					</div>
					<slot name="receiptSubtitle"></slot>
					<div class="icon receipt"></div>
					<span v-if="buyoutReceipt" class="receiptInserted">
						{{ $t('buyout.AdditionalInfoForm.reciept_inserted') }}
					</span>
					<span
						v-if="!buyoutReceipt && !getIsBuyoutEditable"
						class="receiptInserted"
					>
						{{ $t('buyout.AdditionalInfoForm.reciept_cant_insert') }}
					</span>
					<template v-if="!buyoutReceipt && getIsBuyoutEditable">
						<button class="mbtn-info" @click="$refs.receipInputUpload.click()">
							{{ $t('buyout.AdditionalInfoForm.reciept_upload') }}
						</button>
						<input
							v-show="false"
							ref="receipInputUpload"
							type="file"
							accept="application/pdf,image/png,image/jpeg"
							@change="uploadReceipt"
						/>
					</template>
					<template v-if="buyoutReceiptErrors">
						<div class="errors">
							{{ buyoutReceiptErrors }}
						</div>
					</template>
				</v-col>
				<v-col class="collect__imei" v-if="mustHaveImei">
					<slot name="imeiTitle">
						<div
							class="collect__title"
							v-if="selectedBonus && isImeiValidation"
						>
							{{
								$t('buyout.AdditionalInfoForm.register_imei_of_new', [
									campaign.new_devices
								])
							}}
						</div>
						<div
							class="collect__title"
							v-if="!selectedBonus && isImeiValidation"
						>
							{{ $t('buyout.AdditionalInfoForm.register_imei_of_new_global') }}
						</div>
						<div class="collect__title" v-if="!isImeiValidation">
							{{ $t('buyout.AdditionalInfoForm.register_sn_of_new_global') }}
						</div>
					</slot>
					<slot name="imeiSubtitle"></slot>
					<v-text-field
						v-model="newDeviceImei"
						:label="
							$t(
								`buyout.AdditionalInfoForm.${
									isImeiValidation ? 'imei_of_new' : 'sn_of_new'
								}`
							)
						"
						required
						clearable
						:error-messages="_.get(newDeviceImeiErrors, 'new_device_imei')"
						name="new_device_imei"
						autocomplete="off"
						outlined
						:disabled="!getIsBuyoutEditable || !isEditableImei"
					/>
					<button
						v-if="getIsBuyoutEditable && !isEditableImei"
						class="mbtn-info"
						@click="isEditableImei = true"
					>
						{{ $t('buyout.AdditionalInfoForm.edit') }}
					</button>
					<button
						v-if="getIsBuyoutEditable && isEditableImei"
						class="mbtn-info"
						@click="edit_imei"
					>
						{{ $t('buyout.AdditionalInfoForm.save') }}
					</button>
				</v-col>
				<!--				Selectable model-->
				<v-col>
					<template
						v-if="enabledSelectedNewModel && selectedNewModelData.length > 0"
					>
						<div class="collect__title">
							{{ $t('buyout.AdditionalInfoForm.new_selected_model') }}
						</div>
						<div class="semibold text-center pb-6">
							{{ $t('buyout.AdditionalInfoForm.select_new_model_name') }}
						</div>
						<v-autocomplete
							v-model="selectedNewModel"
							:items="selectedNewModelData"
							:disabled="!getIsBuyoutEditable || !newModelEditable"
							item-text="label"
							:placeholder="
								$t('buyout.AdditionalInfoForm.select_new_model_name')
							"
							autocomplete="off"
							outlined
							required
						/>
						<button
							class="mbtn-info"
							v-if="getIsBuyoutEditable && newModelEditable"
							@click="editNewModel"
						>
							Uložit
						</button>
						<button
							class="mbtn-info"
							v-if="getIsBuyoutEditable && !newModelEditable"
							@click="newModelEditable = !newModelEditable"
						>
							{{ $t('buyout.AdditionalInfoForm.edit') }}
						</button>
					</template>
				</v-col>
				<!--				Partner selection-->
				<v-col>
					<template v-if="enabledPartnerSelection && partners.length > 0">
						<div class="collect__title">{{ $t('buyout.AdditionalInfoForm.new_model_partner_main_text') }}</div>
						<div class="semibold text-center pb-6">{{ $t('buyout.AdditionalInfoForm.new_model_partner_sub_text') }}</div>
						<v-autocomplete
							v-model="selectedPartner"
							:items="partners"
							:disabled="!getIsBuyoutEditable || !isNewModelPartnerEditable"
							item-text="name"
							item-value="identifier"
							:placeholder="$t('buyout.AdditionalInfoForm.new_model_partner_selector')"
							autocomplete="off"
							required
							outlined
							return-object
						/>
						<button
							class="mbtn-info"
							v-if="getIsBuyoutEditable && isNewModelPartnerEditable"
							@click="editNewModelPartner"
						>
							Uložit
						</button>
						<button
							class="mbtn-info"
							v-if="getIsBuyoutEditable && !isNewModelPartnerEditable"
							@click="isNewModelPartnerEditable = !isNewModelPartnerEditable"
						>
							{{ $t('buyout.AdditionalInfoForm.edit') }}
						</button>
					</template>
				</v-col>
				<v-col class="collect__address">
					<div class="collect__title">
						{{ $t('buyout.AdditionalInfoForm.order_pickup') }}
					</div>
					<v-row>
						<v-col>
							<v-text-field
								v-model="pickUpAddress.street"
								:label="$t('buyout.AdditionalInfoForm.street')"
								required
								clearable
								:error-messages="_.get(pickupAddressErrors, 'street')"
								name="pickup_address_street"
								autocomplete="off"
								outlined
								:disabled="!canOrderPickUp"
							/>
						</v-col>
						<v-col>
							<v-text-field
								v-model="pickUpAddress.city"
								:label="$t('buyout.AdditionalInfoForm.city')"
								required
								clearable
								:error-messages="_.get(pickupAddressErrors, 'city')"
								name="pickup_address_city"
								autocomplete="off"
								outlined
								:disabled="!canOrderPickUp"
							/>
						</v-col>
						<v-col>
							<v-text-field
								v-model="pickUpAddress.post_code"
								:label="$t('buyout.AdditionalInfoForm.postal')"
								required
								clearable
								:error-messages="_.get(pickupAddressErrors, 'postcode')"
								name="pickup_address_postal"
								autocomplete="off"
								outlined
								:disabled="!canOrderPickUp"
							/>
						</v-col>
					</v-row>
					<button
						class="mbtn-info"
						v-if="getIsBuyoutEditable"
						@click="orderPickUp"
						:disabled="!canOrderPickUp"
					>
						{{ $t('buyout.AdditionalInfoForm.order') }}
					</button>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { VUEX_BUYOUT } from '../../../store/buyout';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { GETTER_TYPES } from '../../../store/buyout/_getter-types';
import { MUTATION_TYPES } from '../../../store/buyout/_mutation-types';
import { ACTION_TYPES } from '../../../store/buyout/_action-types';

export default {
	name: 'AdditionalInfoForm',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		enabledSelectedNewModel: {
			type: Boolean,
			default: false
		},
		enabledPartnerSelection: {
			type: Boolean,
			default: false
		},
		selectedNewModelData: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			newModelEditable: false,
			isNewModelPartnerEditable: false
		}
	},
	created(){
		if(this.enabledPartnerSelection && !this.partners.length>0){
			this[ACTION_TYPES.LOAD_PARTNERS]();
		}
	},
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE, [
			'campaign',
			'newDeviceImeiSaved',
			'buyoutReceipt',
			'selectedBonus',
			'buyoutReceiptErrors',
			'partners'
		]),
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.PICKUP_ADDRESS_ERRORS,
			GETTER_TYPES.IS_BUYOUT_EDITABLE,
			GETTER_TYPES.PICKUP_ADDRESS_ERRORS,
			GETTER_TYPES.EDITABLE_IMEI,
			GETTER_TYPES.GET_SELECTED_NEW_MODEL,
			GETTER_TYPES.GET_SELECTED_NEW_MODEL_PARTNER,
			GETTER_TYPES.GET_BUYOUT_PAYLOAD
		]),
		_() {
			return {
				get
			}
		},
		newDeviceImei: {
			get() {
				return this.$store.getters[
					`${VUEX_BUYOUT.NAMESPACE}/${GETTER_TYPES.NEW_DEVICE_IMEI}`
				];
			},
			set(v) {
				this[MUTATION_TYPES.SET_NEW_DEVICE_IMEI](v);
			}
		},
		newDeviceImeiErrors: {
			get() {
				return this.$store.getters[
					`${VUEX_BUYOUT.NAMESPACE}/${GETTER_TYPES.NEW_DEVICE_IMEI_ERRORS}`
				];
			},
			set(v) {
				this[MUTATION_TYPES.SET_NEW_DEVICE_IMEI_ERRORS](v);
			}
		},
		pickUpAddress: {
			get() {
				return this.$store.getters[
					`${VUEX_BUYOUT.NAMESPACE}/${GETTER_TYPES.PICKUP_ADDRESS}`
				];
			},
			set(v) {
				this[MUTATION_TYPES.SET_PICKUP_ADDRESS](v);
			}
		},
		getIsBuyoutEditable: {
			get() {
				return this[GETTER_TYPES.IS_BUYOUT_EDITABLE];
			}
		},
		selectedNewModel: {
			get() {
				return this[GETTER_TYPES.GET_SELECTED_NEW_MODEL];
			},
			set(v) {
				return this[MUTATION_TYPES.SET_SELECTED_NEW_MODEL](v);
			}
		},
		selectedPartner: {
			get() {
				return this[GETTER_TYPES.GET_SELECTED_NEW_MODEL_PARTNER];
			},
			set(v) {
				return this[MUTATION_TYPES.SET_SELECTED_NEW_MODEL_PARTNER](v);
			}
		},
		mustHaveImei() {
			return this.campaign && this.campaign.is_imei;
		},
		mustHaveReciept() {
			return this.campaign && this.campaign.is_receipt;
		},
		isImeiValidation() {
			return this.campaign && this.campaign.new_device_imei_validation_required;
		},
		canOrderPickUp() {
			return (
				this.getIsBuyoutEditable &&
				((this.mustHaveReciept && this.buyoutReceipt) ||
					!this.mustHaveReciept) &&
				((this.mustHaveImei && this.newDeviceImeiSaved) || !this.mustHaveImei) &&
				((this.enabledPartnerSelection && !this.isNewModelPartnerEditable && this.selectedPartner) || !this.enabledSelectedNewModel) &&
				((this.enabledSelectedNewModel && !this.newModelEditable && this.selectedNewModel) || ! this.enabledSelectedNewModel)
			);
		},
		isEditableImei: {
			get() {
				return this[GETTER_TYPES.EDITABLE_IMEI];
			},
			set(v) {
				this[MUTATION_TYPES.SET_EDITABLE_IMEI](v);
				this[MUTATION_TYPES.SET_NEW_DEVICE_IMEI_SAVED](false);
			}
		}
	},
	methods: {
		...mapMutations(VUEX_BUYOUT.NAMESPACE, [
			MUTATION_TYPES.SET_NEW_DEVICE_IMEI,
			MUTATION_TYPES.SET_NEW_DEVICE_IMEI_ERRORS,
			MUTATION_TYPES.SET_EDITABLE_IMEI,
			MUTATION_TYPES.SET_NEW_DEVICE_IMEI_SAVED,
			MUTATION_TYPES.SET_PICKUP_ADDRESS,
			MUTATION_TYPES.SET_SELECTED_NEW_MODEL,
			MUTATION_TYPES.SET_SELECTED_NEW_MODEL_PARTNER
		]),
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.ORDER_PICKUP,
			ACTION_TYPES.EDIT_IMEI,
			ACTION_TYPES.UPLOAD_RECEIPT,
			ACTION_TYPES.EDIT_SELECTED_NEW_MODEL,
			ACTION_TYPES.LOAD_PARTNERS,
			ACTION_TYPES.SEND_APPRAISAL
		]),
		async orderPickUp() {
			this[MUTATION_TYPES.SET_PICKUP_ADDRESS](this.pickUpAddress);
			this[ACTION_TYPES.ORDER_PICKUP]();
			this.$emit('pickup-ordered');
		},
		async edit_imei() {
			this[ACTION_TYPES.EDIT_IMEI]();
			if (isEmpty(this.newDeviceImeiErrors)) {
				this[MUTATION_TYPES.SET_NEW_DEVICE_IMEI_SAVED](true);
			}
		},
		async editNewModel() {
			this[ACTION_TYPES.EDIT_SELECTED_NEW_MODEL]();
			this.newModelEditable = !this.newModelEditable;
		},
		async editNewModelPartner() {
			this[ACTION_TYPES.SEND_APPRAISAL]({payload: this[GETTER_TYPES.GET_BUYOUT_PAYLOAD],partner_edit: true});
			this.isNewModelPartnerEditable = !this.isNewModelPartnerEditable;
		},
	}
}
</script>
